export class UserStatusLoginError extends Error {
	constructor(public message: string, public extraInfo: { [key: string]: string }, public originalError: Error) {
		super(message);
		// Set the prototype explicitly.
		// https://github.com/microsoft/TypeScript-wiki/blob/94fb0618c7185f86afec26e6b4d2d6eb7c049e47/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
		Object.setPrototypeOf(this, UserStatusLoginError.prototype);
	}
}
